module.exports = __webpack_public_path__ + "static/media/5DPO15.02496df7.jpg";